import Registration from './registration';

export default Registration;
